/**
 * Product Benefits Section with Drawer Functionality
 */
(() => {
  'use strict';

  const SECTION_SELECTOR = '[data-product-benefits-section]';
  const DRAWER_SELECTOR = '[data-product-benefits-drawer]';
  const TRIGGER_SELECTOR = '[data-product-benefits-trigger]';
  const DRAWER_CONTENT_SELECTOR = '[data-product-benefits-drawer-content]';
  const DRAWER_HEADING_SELECTOR = '[data-product-benefits-drawer-heading]';
  const DRAWER_CLOSE_SELECTOR = '[data-product-benefits-drawer-close]';

  const initProductBenefitsSection = (section) => {
    if (!section || section.dataset.productBenefitsInitialized === 'true') {
      return;
    }

    const drawer = section.querySelector(DRAWER_SELECTOR);
    if (!drawer) {
      return;
    }

    const drawerContent = drawer.querySelector(DRAWER_CONTENT_SELECTOR);
    const drawerHeading = drawer.querySelector(DRAWER_HEADING_SELECTOR);
    const defaultHeading = drawerHeading ? drawerHeading.textContent.trim() : '';

    const parentSectionElement = section.closest('[data-section-id]');
    const parentSectionId = parentSectionElement ? parentSectionElement.dataset.sectionId : section.id || '';
    if (parentSectionId) {
      drawer.dataset.parentSection = parentSectionId;
    }

    // Move drawer to body for proper z-index stacking (like ingredient drawer)
    if (!drawer.dataset.productBenefitsDrawerMounted) {
      drawer.dataset.productBenefitsDrawerMounted = 'true';
      document.body.appendChild(drawer);
    }

    const triggers = section.querySelectorAll(TRIGGER_SELECTOR);
    const closeButtons = drawer.querySelectorAll(DRAWER_CLOSE_SELECTOR);

    if (!drawerContent) {
      return;
    }

    const openDrawer = (headingText, contentHtml) => {
      if (!drawerContent) return;
      
      drawerContent.innerHTML = contentHtml;
      // Reset scroll position to top
      drawerContent.scrollTop = 0;
      if (drawerHeading) {
        drawerHeading.textContent = headingText || defaultHeading;
      }
      
      if (!drawer.classList.contains('animate')) {
        drawer.classList.add('animate');
      }
      drawer.classList.add('active');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
    };

    const closeDrawer = () => {
      drawer.classList.remove('active', 'is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (drawerContent) {
        drawerContent.innerHTML = '';
      }
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
      if (drawerHeading) {
        drawerHeading.textContent = defaultHeading;
      }
    };

    // Attach click handlers to triggers
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const headingText = trigger.getAttribute('data-product-benefits-heading') || 'Benefit details';
        const contentSource = trigger.querySelector('.product-benefits__benefit-content-source');
        const contentHtml = contentSource ? contentSource.innerHTML : '';
        
        if (contentHtml) {
          openDrawer(headingText, contentHtml);
        }
      });
    });

    // Attach close handlers
    closeButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        closeDrawer();
      });
    });

    // Close on overlay click
    const overlay = drawer.querySelector('.cart-drawer__overlay');
    if (overlay) {
      overlay.addEventListener('click', () => {
        closeDrawer();
      });
    }

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('active')) {
        closeDrawer();
      }
    });

    section.dataset.productBenefitsInitialized = 'true';
  };

  const initAllSections = (root = document) => {
    if (!root) {
      return;
    }

    if (root.matches && root.matches(SECTION_SELECTOR)) {
      initProductBenefitsSection(root);
      return;
    }

    root.querySelectorAll(SECTION_SELECTOR).forEach((section) => initProductBenefitsSection(section));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllSections());
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllSections(event.target || document);
  });

  document.addEventListener('shopify:section:select', (event) => {
    initAllSections(event.target || document);
  });
})();
